import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from "clsx";
const WORDMARK_AVIF = "/gruvlogolargosmall.avif";
const WORDMARK_PNG = "/gruvlogolargosmall.png";
/** Aspect ratio of gruvlogolargosmall (660×226). */
const WORDMARK_ASPECT = 660 / 226;
/**
 * Renders the horizontal GRUV wordmark with AVIF-first delivery.
 */
export function GruvWordmark({ className, height = 28, priority = false, ...props }) {
    const width = Math.round(height * WORDMARK_ASPECT);
    return (_jsxs("picture", { className: "gruv-wordmark", children: [_jsx("source", { srcSet: WORDMARK_AVIF, type: "image/avif" }), _jsx("img", { src: WORDMARK_PNG, alt: "GRUV", width: width, height: height, className: clsx("block h-auto w-auto object-contain", className), style: { height, width: "auto", maxWidth: "100%" }, fetchPriority: priority ? "high" : undefined, ...props })] }));
}
